(() => {
  const isClickDummy = (
    window.swinger.config
    && window.swinger.config.isClickDummy
  );

  if (!isClickDummy) {
    return;
  }

  window.swinger.eventHub.register('submit', '.swinger-searchform', (e) => {
    const form = window.swinger.eventHub.getTarget(e);
    form.action = './suche.html';
  });

  window.swinger.eventHub.register('submit', '.swinger-login form', (e) => {
    const form = window.swinger.eventHub.getTarget(e);

    if (form.checkValidity && form.checkValidity()) {
      window.swinger.user.login();
      document.querySelector('#swinger-usermenu__toggle').focus();
      window.setTimeout(() => {
        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = false;
        });
        window.swinger.visibility.hide(document.querySelector('#swinger-login__wrapper-login'));
      }, 100);
    }

    e.preventDefault();
  });

  window.swinger.eventHub.register('click', '[data-logout]', (e) => {
    window.swinger.user.logout();
    document.querySelector('#header-button-login').focus();

    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.snackbar.create({
          isSelfclosing: true,
          children: [
            {
              component: 'notification',
              data: {
                type: 'success',
                text: i18n('ui.shared.logout-successful'),
              },
            },
          ],
        });
      })
      .catch(console.info);

    e.preventDefault();
  });

  window.swinger.eventHub.register('click', [
    'a[href^="/filme"]',
    'a[href^="/movies"]',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = link.href.replace('/filme', '/filme.html');
    link.href = link.href.replace('/filme.html.html', '/filme.html');
    link.href = link.href.replace('/movies', '/filme.html');
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    'a[href^="/cart"]',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = link.href.replace('/cart', '/cart.html');
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--category .swinger-card__link',
    '.swinger-tags__item',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = '/filme.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--movie .swinger-card__link',
    '.swinger-factslist__definition--movie .swinger-factslist__link',
    '.swinger-slider--card-scene .swinger-slider__item--cover .swinger-card__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'film.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-factslist__definition--series .swinger-factslist__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'serie.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-factslist__definition--directors .swinger-factslist__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'regisseur.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--scene .swinger-card__link',
    '.swinger-scene-box__preview-link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'szene.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--studio .swinger-card__link',
    '.swinger-card--movie .swinger-card__kicker-link',
    '.swinger-card--scene .swinger-card__kicker-link',
    '.swinger-studio-box__link',
    '.swinger-factslist__definition--studio .swinger-factslist__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'studio.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--performer .swinger-card__link',
    '.swinger-avatar__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'darsteller.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--amateur .swinger-card__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'amateur.html';
    link.target = '_self';
  });

  window.swinger.eventHub.register('click', [
    '.swinger-card--clip .swinger-card__link',
  ].join(','), (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('a');

    link.href = 'clip.html';
    link.target = '_self';
  });
})();
